export enum TransactionTypes {
  B2B_HV = 7,
  B2C_HV = 8,
  B2C_HV_BEGATE = 9,
  B2B2C_HV = 10,
  B2B_MULTIPLE = 11,
  B2C_C2C_HV = 12,
  B2C_C2C_HV_H1_BUYER = 13,
  B2B_EXPORT = 15,
  B2C_EXPORT_MULTI = 16,
}
